export default __webpack_public_path__ + "static/media/logo.b677ec04.svg";